export default "__VITE_ASSET__DJCSfFc2__"